import React from "react"
import { twMerge } from "tailwind-merge";

const Textarea = React.forwardRef((props: any, ref: any) => {
  return (
    <textarea 
      ref={ref}
      {...props}
      rows={5}
      className={twMerge(`block p-2.5 w-full text-sm text-gray-900 rounded-lg border ${
        props.error
          ? "border-red-600 focus:border-red-600"
          : "border-gray-300 focus:border-brand-500"
        } focus:ring-transparent`, props?.className)}
      placeholder={props.placeholder ?? "Write here..."}
    />
  )
});


Textarea.displayName = "Textarea";

export default Textarea;